import { styled, TextField } from '@mui/material';
import { useState } from 'react';
import { FormationWithOptions } from './FormationWithOptions';
import { FormationWithoutOptions } from './FormationWithoutOptions';
// import { Master } from './Master';
import { Fundings } from './Fundings';
import { List, ListItem } from '../../../components/List';
import { useApiCall } from '../../../lib/useApiCall';
import { api, formationContinueDtoType } from '../../../lib/api';
import { useNavigate } from 'react-router-dom';
import { pathHandler } from '../../../lib/pathHandler';
import { Button } from '../../../components/Button';
import { SummaryTable } from './SummaryTable';

import { FormLayout } from '../../../components/FormLayout';
import { Section } from '../../../components/Section';
import {
    formationWithOptionSlugType,
    formationWithOptionsType,
    formationWithoutOptionSlugType,
    formationWithoutOptionsType,
    fundingType,
    selectedTrainingsType,
    // masterSlugType,
    TRAINING_WITH_OPTIONS_SLUGS,
    TRAINING_WITHOUT_OPTIONS_SLUGS,
} from '../../types';

const DEFAULT_TRAINING_WITH_OPTIONS: formationWithOptionsType = {
    option: undefined,
    date: '',
};
const DEFAULT_TRAINING_WITHOUT_OPTIONS: formationWithoutOptionsType = {
    date: '',
    isSelected: false,
};

const INITIAL_FORMATIONS_WITH_OPTIONS_SUMMARY = TRAINING_WITH_OPTIONS_SLUGS.reduce(
    (acc, TRAINING_WITH_OPTIONS_SLUG) => {
        return { ...acc, [TRAINING_WITH_OPTIONS_SLUG]: DEFAULT_TRAINING_WITH_OPTIONS };
    },
    {} as Record<formationWithOptionSlugType, formationWithOptionsType>,
);

const INITIAL_FORMATIONS_WITHOUT_OPTIONS_SUMMARY = TRAINING_WITHOUT_OPTIONS_SLUGS.reduce(
    (acc, TRAINING_WITHOUT_OPTIONS_SLUG) => {
        return { ...acc, [TRAINING_WITHOUT_OPTIONS_SLUG]: DEFAULT_TRAINING_WITHOUT_OPTIONS };
    },
    {} as Record<formationWithoutOptionSlugType, formationWithoutOptionsType>,
);

function FormationContinue() {
    const [formTextData, setTextFormData] = useState({
        firstName: '',
        lastName: '',
        birthdate: '',
        placeOfBirth: '',
        nationality: '',
        email: '',
        phoneNumber: '',
        address: '',
        zipCode: '',
        town: '',
        diploma1: '',
        institution1: '',
        graduationYear1: '',
        diploma2: '',
        institution2: '',
        graduationYear2: '',
        diploma3: '',
        institution3: '',
        graduationYear3: '',
        jobTitle1: '',
        company1: '',
        jobDuration1: '',
        jobTitle2: '',
        company2: '',
        jobDuration2: '',
        jobTitle3: '',
        company3: '',
        jobDuration3: '',
    });

    const navigate = useNavigate();

    const createFormationContinueEntryApiCall = useApiCall({
        apiCall: api.createFormationContinueEntry,
        onSuccess: () => {
            navigate(pathHandler.getRoutePath('INSCRIPTION_SUCCESS'));
        },
    });

    const [formationsWithOptionsSummary, setFormationsWithOptionsSummary] = useState(
        INITIAL_FORMATIONS_WITH_OPTIONS_SUMMARY,
    );
    const [formationsWithoutOptionsSummary, setFormationsWithoutOptionsSummary] = useState(
        INITIAL_FORMATIONS_WITHOUT_OPTIONS_SUMMARY,
    );

    // const [selectedMaster, setSelectedMaster] = useState<masterSlugType | undefined>();
    const [funding, setFunding] = useState<fundingType>({ kind: 'auto' });

    return (
        <FormLayout
            handleSubmit={handleSubmit}
            title="FORMATION CONTINUE"
            subtitle="Demande d'inscription"
        >
            <Section variant="h2" title="INFORMATIONS PERSONNELLES">
                <Row>
                    <TextField
                        fullWidth
                        onChange={handleFormChange}
                        required
                        label="Prénom"
                        placeholder="Jeanne"
                        name="firstName"
                        value={formTextData.firstName}
                    />
                    <TextField
                        fullWidth
                        onChange={handleFormChange}
                        required
                        label="Nom"
                        placeholder="Dupont"
                        name="lastName"
                        value={formTextData.lastName}
                    />
                </Row>
                <Row>
                    <TextFieldContainer width="14vw">
                        <TextField
                            style={{ width: '14vw' }}
                            onChange={handleFormChange}
                            required
                            label="Date de naissance"
                            type="date"
                            name="birthdate"
                            placeholder="JJ/MM/AAAA"
                            value={formTextData.birthdate}
                            InputLabelProps={{ shrink: true }}
                        />
                    </TextFieldContainer>
                    <TextField
                        onChange={handleFormChange}
                        required
                        label="Lieu de naissance"
                        fullWidth
                        placeholder="Paris (75)"
                        name="placeOfBirth"
                        value={formTextData.placeOfBirth}
                    />
                    <TextFieldContainer width="28vw">
                        <TextField
                            style={{ width: '28vw' }}
                            onChange={handleFormChange}
                            required
                            label="Nationalité"
                            placeholder="Française"
                            name="nationality"
                            value={formTextData.nationality}
                        />
                    </TextFieldContainer>
                </Row>
                <Row>
                    <TextField
                        onChange={handleFormChange}
                        required
                        label="Email"
                        type="email"
                        placeholder="jeanne.dupont@email.com"
                        name="email"
                        fullWidth
                        value={formTextData.email}
                    />
                    <TextFieldContainer width="28vw">
                        <TextField
                            style={{ width: '28vw' }}
                            onChange={handleFormChange}
                            required
                            type="tel"
                            placeholder="06 12 34 56 78"
                            label="Téléphone"
                            name="phoneNumber"
                            value={formTextData.phoneNumber}
                        />
                    </TextFieldContainer>
                </Row>
                <Row>
                    <TextField
                        onChange={handleFormChange}
                        required
                        label="Adresse"
                        name="address"
                        value={formTextData.address}
                        fullWidth
                    />
                    <TextFieldContainer width="14vw">
                        <TextField
                            style={{ width: '14vw' }}
                            onChange={handleFormChange}
                            required
                            label="Code postal"
                            name="zipCode"
                            value={formTextData.zipCode}
                        />
                    </TextFieldContainer>
                    <TextFieldContainer width="14vw">
                        <TextField
                            style={{ width: '14vw' }}
                            onChange={handleFormChange}
                            required
                            label="Ville"
                            name="town"
                            value={formTextData.town}
                        />
                    </TextFieldContainer>
                </Row>
            </Section>

            <Section title="PARCOURS ÉTUDIANT ET PROFESSIONNEL" variant="h2">
                <Section variant="h3" title="Diplôme(s) obtenu(s) (+ année et établissement)">
                    <List>
                        <ListItem>
                            <TextField
                                onChange={handleFormChange}
                                value={formTextData.diploma1}
                                label="Diplôme"
                                name="diploma1"
                                fullWidth
                            />
                            <TextField
                                required={!!formTextData.diploma1}
                                onChange={handleFormChange}
                                label="Établissement"
                                value={formTextData.institution1}
                                name="institution1"
                                fullWidth
                            />
                            <TextField
                                required={!!formTextData.diploma1}
                                onChange={handleFormChange}
                                label="Année"
                                type="number"
                                name="graduationYear1"
                                value={formTextData.graduationYear1}
                            />
                        </ListItem>
                        <ListItem>
                            <TextField
                                onChange={handleFormChange}
                                value={formTextData.diploma2}
                                label="Diplôme"
                                name="diploma2"
                                fullWidth
                            />
                            <TextField
                                onChange={handleFormChange}
                                required={!!formTextData.diploma2}
                                label="Établissement"
                                value={formTextData.institution2}
                                name="institution2"
                                fullWidth
                            />
                            <TextField
                                onChange={handleFormChange}
                                required={!!formTextData.diploma2}
                                label="Année"
                                type="number"
                                name="graduationYear2"
                                value={formTextData.graduationYear2}
                            />
                        </ListItem>
                        <ListItem>
                            <TextField
                                onChange={handleFormChange}
                                value={formTextData.diploma3}
                                label="Diplôme"
                                name="diploma3"
                                fullWidth
                            />
                            <TextField
                                onChange={handleFormChange}
                                required={!!formTextData.diploma3}
                                label="Établissement"
                                value={formTextData.institution3}
                                name="institution3"
                                fullWidth
                            />
                            <TextField
                                onChange={handleFormChange}
                                required={!!formTextData.diploma3}
                                label="Année"
                                type="number"
                                name="graduationYear3"
                                value={formTextData.graduationYear3}
                            />
                        </ListItem>
                    </List>
                </Section>
            </Section>
            <Section title="Derniers postes occupés (+ durée et entreprise)" variant="h3">
                <List>
                    <ListItem>
                        <TextField
                            onChange={handleFormChange}
                            value={formTextData.jobTitle1}
                            label="Intitulé du poste"
                            name="jobTitle1"
                            fullWidth
                        />
                        <TextField
                            required={!!formTextData.jobTitle1}
                            onChange={handleFormChange}
                            label="Entreprise"
                            value={formTextData.company1}
                            name="company1"
                            fullWidth
                        />
                        <TextField
                            required={!!formTextData.jobTitle1}
                            onChange={handleFormChange}
                            label="Durée"
                            name="jobDuration1"
                            value={formTextData.jobDuration1}
                        />
                    </ListItem>
                    <ListItem>
                        <TextField
                            onChange={handleFormChange}
                            value={formTextData.jobTitle2}
                            label="Intitulé du poste"
                            name="jobTitle2"
                            fullWidth
                        />
                        <TextField
                            required={!!formTextData.jobTitle2}
                            onChange={handleFormChange}
                            label="Entreprise"
                            value={formTextData.company2}
                            name="company2"
                            fullWidth
                        />
                        <TextField
                            required={!!formTextData.jobTitle2}
                            onChange={handleFormChange}
                            label="Durée"
                            value={formTextData.jobDuration2}
                            name="jobDuration2"
                            placeholder="2022"
                        />
                    </ListItem>
                    <ListItem>
                        <TextField
                            onChange={handleFormChange}
                            value={formTextData.jobTitle3}
                            label="Intitulé du poste"
                            name="jobTitle3"
                            fullWidth
                        />
                        <TextField
                            required={!!formTextData.jobTitle3}
                            onChange={handleFormChange}
                            label="Entreprise"
                            value={formTextData.company3}
                            name="company3"
                            fullWidth
                        />
                        <TextField
                            required={!!formTextData.jobTitle3}
                            onChange={handleFormChange}
                            label="Durée"
                            name="jobDuration3"
                            value={formTextData.jobDuration3}
                        />
                    </ListItem>
                </List>
            </Section>

            <Section title="FORMATION(S) CHOISIE(S)" variant="h2">
                <Section title="FORMATIONS BIODIVERSITÉ ET ÉCOLOGIE" variant="h3">
                    <FormationWithOptions
                        slug="JARDIN_BIODIVERSITE_2026_2027"
                        formationsWithOptionsSummary={formationsWithOptionsSummary}
                        setFormationsWithOptionsSummary={setFormationsWithOptionsSummary}
                    />
                    <FormationWithOptions
                        slug="FAUNE_2026_2027"
                        formationsWithOptionsSummary={formationsWithOptionsSummary}
                        setFormationsWithOptionsSummary={setFormationsWithOptionsSummary}
                    />
                    <FormationWithOptions
                        slug="EAU_FRAICHEUR_URBAINE_2026_2027"
                        formationsWithOptionsSummary={formationsWithOptionsSummary}
                        setFormationsWithOptionsSummary={setFormationsWithOptionsSummary}
                    />
                    <FormationWithOptions
                        slug="SOLS_BIODIVERSITE_2026_2027"
                        formationsWithOptionsSummary={formationsWithOptionsSummary}
                        setFormationsWithOptionsSummary={setFormationsWithOptionsSummary}
                    />
                    <FormationWithOptions
                        slug="VEGETALISER_VILLE_2026_2027"
                        formationsWithOptionsSummary={formationsWithOptionsSummary}
                        setFormationsWithOptionsSummary={setFormationsWithOptionsSummary}
                    />
                    <FormationWithOptions
                        slug="GESTION_ECOLOGIQUE_2026_2027"
                        formationsWithOptionsSummary={formationsWithOptionsSummary}
                        setFormationsWithOptionsSummary={setFormationsWithOptionsSummary}
                    />
                    <FormationWithOptions
                        slug="EVALUER_IMPACT_ENVIRONNEMENTAL_2026_2027"
                        formationsWithOptionsSummary={formationsWithOptionsSummary}
                        setFormationsWithOptionsSummary={setFormationsWithOptionsSummary}
                    />
                    <FormationWithOptions
                        slug="ECONOMIE_CIRCULAIRE_REEMPLOI_2026_2027"
                        formationsWithOptionsSummary={formationsWithOptionsSummary}
                        setFormationsWithOptionsSummary={setFormationsWithOptionsSummary}
                    />
                </Section>
                <Section title="FORMATIONS CONCEPTION ET MÉTIER" variant="h3">
                    <FormationWithOptions
                        slug="IA_CONCEPTION_PAYSAGE_2026_2027"
                        formationsWithOptionsSummary={formationsWithOptionsSummary}
                        setFormationsWithOptionsSummary={setFormationsWithOptionsSummary}
                    />
                    <FormationWithOptions
                        slug="IA_GESTION_ADMINISTRATIVE_2026_2027"
                        formationsWithOptionsSummary={formationsWithOptionsSummary}
                        setFormationsWithOptionsSummary={setFormationsWithOptionsSummary}
                    />
                    <FormationWithOptions
                        slug="IA_APPEL_OFFRE_2026_2027"
                        formationsWithOptionsSummary={formationsWithOptionsSummary}
                        setFormationsWithOptionsSummary={setFormationsWithOptionsSummary}
                    />
                    <FormationWithOptions
                        slug="MODELISATION_3D_2026_2027"
                        formationsWithOptionsSummary={formationsWithOptionsSummary}
                        setFormationsWithOptionsSummary={setFormationsWithOptionsSummary}
                    />
                    <FormationWithOptions
                        slug="SIG_PAYSAGE_2026_2027"
                        formationsWithOptionsSummary={formationsWithOptionsSummary}
                        setFormationsWithOptionsSummary={setFormationsWithOptionsSummary}
                    />
                    <FormationWithOptions
                        slug="PLU_PAYSAGE_2026_2027"
                        formationsWithOptionsSummary={formationsWithOptionsSummary}
                        setFormationsWithOptionsSummary={setFormationsWithOptionsSummary}
                    />
                </Section>
                <Section title="FORMATIONS ENTRETIEN & AMÉNAGEMENT" variant="h3">
                    <FormationWithoutOptions
                        slug="ENTRETIEN_ESPACE_VERT_2026_2027"
                        formationsWithoutOptionsSummary={formationsWithoutOptionsSummary}
                        setFormationsWithoutOptionsSummary={setFormationsWithoutOptionsSummary}
                    />
                    <FormationWithoutOptions
                        slug="ALTERNATIVES_ARROSAGE_2026_2027"
                        formationsWithoutOptionsSummary={formationsWithoutOptionsSummary}
                        setFormationsWithoutOptionsSummary={setFormationsWithoutOptionsSummary}
                    />
                    <FormationWithoutOptions
                        slug="REALISER_UN_MASSIF_2026_2027"
                        formationsWithoutOptionsSummary={formationsWithoutOptionsSummary}
                        setFormationsWithoutOptionsSummary={setFormationsWithoutOptionsSummary}
                    />
                </Section>
                <Section title="FORMATIONS INITIATION AU PAYSAGE" variant="h3">
                    <FormationWithOptions
                        slug="CONCEVOIR_JARDIN_PRIVE_2026_2027"
                        formationsWithOptionsSummary={formationsWithOptionsSummary}
                        setFormationsWithOptionsSummary={setFormationsWithOptionsSummary}
                    />
                    <FormationWithOptions
                        slug="HISTOIRE_JARDINS_2026_2027"
                        formationsWithOptionsSummary={formationsWithOptionsSummary}
                        setFormationsWithOptionsSummary={setFormationsWithOptionsSummary}
                    />
                </Section>
            </Section>
            <Section title="4. Financement" variant="h2">
                <Fundings funding={funding} setFunding={setFunding} />
            </Section>

            <Section title="5. Récapitulatif" variant="h2">
                <SummaryTable
                    selectedMaster={undefined}
                    formationsWithoutOptionsSummary={formationsWithoutOptionsSummary}
                    formationsWithOptionsSummary={formationsWithOptionsSummary}
                    funding={funding}
                />
            </Section>
            <Button
                loadingText="Envoi de la demande en cours... Cela peut prendre quelques secondes."
                isLoading={createFormationContinueEntryApiCall.isLoading}
                fullWidth
                type="submit"
                variant="contained"
                color="primary"
            >
                ENVOYER LA DEMANDE D'INSCRIPTION
            </Button>
        </FormLayout>
    );

    function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();
        const formationContinueDto = computeFormationContinueDto();
        createFormationContinueEntryApiCall.perform(formationContinueDto);
    }

    function computeFormationContinueDto(): formationContinueDtoType {
        const fundingDetails =
            funding.kind === 'company' || funding.kind === 'opco'
                ? {
                      company: funding.company,
                      siret: funding.siret,
                      address: funding.address,
                      managementName: funding.managementName,
                      managementEmail: funding.managementEmail,
                  }
                : undefined;

        const selectedTrainings = computeSelectedTrainings();
        return {
            firstName: formTextData.firstName,
            lastName: formTextData.lastName,
            birthdate: formTextData.birthdate,
            placeOfBirth: formTextData.placeOfBirth,
            nationality: formTextData.nationality,
            email: formTextData.email,
            phoneNumber: formTextData.phoneNumber,
            address: formTextData.address,
            zipCode: formTextData.zipCode,
            town: formTextData.town,
            diploma1: formTextData.diploma1,
            institution1: formTextData.institution1,
            graduationYear1: formTextData.graduationYear1,
            diploma2: formTextData.diploma2,
            institution2: formTextData.institution2,
            graduationYear2: formTextData.graduationYear2,
            diploma3: formTextData.diploma3,
            institution3: formTextData.institution3,
            graduationYear3: formTextData.graduationYear3,
            jobTitle1: formTextData.jobTitle1,
            company1: formTextData.company1,
            jobDuration1: formTextData.jobDuration1,
            jobTitle2: formTextData.jobTitle2,
            company2: formTextData.company2,
            jobDuration2: formTextData.jobDuration2,
            jobTitle3: formTextData.jobTitle3,
            company3: formTextData.company3,
            jobDuration3: formTextData.jobDuration3,
            selectedTrainings,
            // selectedMaster: selectedMaster,
            selectedMaster: undefined,
            fundingKind: funding.kind,
            fundingDetails,
        };
    }

    function computeSelectedTrainings() {
        const selectedTrainings = {} as selectedTrainingsType;
        TRAINING_WITH_OPTIONS_SLUGS.forEach((slug) => {
            if (
                !!formationsWithOptionsSummary[slug].option &&
                !!formationsWithOptionsSummary[slug].date
            ) {
                selectedTrainings[slug] = {
                    trainingOption: formationsWithOptionsSummary[slug].option!,
                    date: formationsWithOptionsSummary[slug].date,
                };
            }
        });
        TRAINING_WITHOUT_OPTIONS_SLUGS.forEach((slug) => {
            if (!!formationsWithoutOptionsSummary[slug].date) {
                selectedTrainings[slug] = {
                    trainingOption: 'intra',
                    date: formationsWithoutOptionsSummary[slug].date,
                };
            }
        });
        return selectedTrainings;
    }

    function handleFormChange(event: React.ChangeEvent<HTMLInputElement>) {
        const { name, value } = event.target;
        setTextFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    }
}

const TextFieldContainer = styled('div')<{ width: string }>(({ theme, width }) => ({
    width,
}));

const Row = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
}));

export { FormationContinue };
